module.exports = __webpack_public_path__ + "img/precificacao.7af27f77.svg";